export const LOCAL_NEW_STATE = "local-new";
export const LOCAL_UPDATE_STATE = "local-update";
export const SEND_STATE = "send";
